<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[90%] xl:w-[85%] max-h-screen bg-[#f8f8f8] px-[12px] md:px-[30px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Create New Order
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
      </div>
      <div
        class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
      >
        <div>
          <div>
            <h3
              v-if="buyerId && order.orderNumber"
              class="text-[20px] leading-[20px] text-[#2463EB] font-bold mb-[24px]"
            >
              Order # {{ order.orderNumber }}
            </h3>
            <h4
              v-if="!value"
              class="text-[18px] font-semibold text-[#353535] leading-[21.78px] mb-[16px]"
            >
              Select a customer
            </h4>
          </div>

          <!-- select customer -->
          <div class="" v-if="!value">
            <label class="text-[14px] leading-[20px] font-medium text-[#353535]"
              >Customer</label
            >
            <div class="max-w-[350px] w-full">
              <multiselect
                v-model="value"
                label="text"
                track-by="id"
                :options="customers"
                @select="onSelect"
              ></multiselect>
            </div>
          </div>
          <!-- buyers details -->
          <div v-else>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Order for
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ order.buyer ? order.buyer.displayName : "" }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Phone Number
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ buyerPhone }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Email
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ buyerEmailAddress }}</span
              >
            </div>
            <div
              v-if="user.role !== 'Sales'"
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2 max-w-[500px] w-full"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Account Manager
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                >{{ order.salesReps }}</span
              >
            </div>
            <div
              class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2"
            >
              <h2
                class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full"
              >
                Ledger Balance
              </h2>
              <span
                class="font-medium text-[16px] text-[#353535] leading-[19.36px]"
                :style="[
                  parseInt(customerOutstandingBalance) <= 0
                    ? {
                        color: '#DC2828',
                        'font-size': '15px',
                        'font-weight': 'normal',
                      }
                    : {
                        color: '#28C76F',
                        'font-size': '15px',
                        'font-weight': 'normal',
                      },
                ]"
                >&#8358;{{ formatMoney(customerOutstandingBalance) }}</span
              >
            </div>
            <div class="flex items-center gap-[24px] mt-[24px] w-full">
              <div class="max-w-[400px] w-full">
                <label
                  class="font-medium text-[14px] text-[#353535] leading-[20px] mb-[10px]"
                  >Order Date</label
                >
                <input
                  :class="['form-control', { 'is-invalid': v1.orderDate }]"
                  type="date"
                  :max="maxDate"
                  class="font-normal text-[14px] text-[#353535] leading-[24px] border-[1.5px] w-full border-solid border-[#D0D5DD] px-[14px] rounded-[8px]"
                  placeholder="Select a Date"
                  v-model="orderDate"
                />
                <ul v-if="v1.orderDate" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
              <div class="max-w-[400px] w-full">
                <label
                  class="font-medium text-[14px] text-[#353535] leading-[20px] mb-[10px]"
                  >Delivery Address</label
                >
                <input
                  class="font-normal text-[14px] text-[#353535] leading-[24px] border-[1.5px] w-full border-solid py-[5px] border-[#D0D5DD] px-[14px] rounded-[8px]"
                  placeholder="Delivery address for this order"
                  v-model="deliveryAddress"
                  type="text"
                />
                <ul
                  v-if="v1.deliveryAddress"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- order details -->
      <div
        class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
      >
        <div class="flex items-center justify-between">
          <h4
            class="text-[18px] font-semibold text-[#353535] leading-[21.78px] mb-[16px]"
          >
            Order details
          </h4>
          <button
            :disabled="!value"
            class="bg-[#2463EB] text-white text-[14px] leading-[20px] border-[#2463EB] border-solid rounded-[8px] outline-none focus:outline-none p-[8px] disabled:cursor-not-allowed"
            @click="viewAdd"
          >
            <span class="mdi mdi-plus"></span>
            Add item
          </button>
        </div>
        <div class="table-responsive my-[16px]">
          <table class="table w-full min-h-[150px] text-nowrap">
            <thead class="bg-white">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Description
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Quantity
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Unit Price
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Sub Total
                </th>
                <th
                  width="3%"
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Discount
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Total
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="(item, index) in orderDetails" :key="index">
                <td class="align-middle">
                  <div class="flex items-center gap-[16px]">
                    <img
                      v-if="item.imageUrl"
                      :src="item.imageUrl"
                      :alt="item.name"
                      class="w-[60px] h-[100px] object-contain"
                    />
                    <div
                      class="mt-[5px] flex flex-col gap-[4px] mr-[5px] py-[5px]"
                    >
                      <p
                        class="text-[14px] font-medium leading-[16.94px] mb-[4px] text-[#1e1e1e]"
                      >
                        {{ item.name }} ({{ item.code }})
                      </p>
                      <p
                        class="max-w-[600px] w-full text-[12px] italic font-normal leading-[16.94px] text-[#353535]"
                      >
                        N{{ item.unitPrice }}/{{ item.unit }}
                      </p>
                    </div>
                  </div>
                </td>
                <td class="align-middle">{{ item.quantity }}</td>
                <td class="align-middle">
                  &#8358;
                  {{ formatMoney(item.unitPrice) }}
                </td>
                <td class="align-middle">
                  &#8358;
                  {{ formatMoney((item.quantity * item.unitPrice).toFixed(2)) }}
                </td>
                <td class="align-middle">
                  <input
                    class="w-[120px] border-[3px] px-[12px] py-[2px] outline-none focus:outline-none"
                    type="number"
                    step="0.01"
                    v-model="item.discount"
                  />
                </td>
                <td class="align-middle">
                  &#8358;
                  {{
                    formatMoney(
                      (item.quantity * item.unitPrice - item.discount).toFixed(
                        2
                      )
                    )
                  }}
                </td>
                <td class="align-middle">
                  <button
                    @click.prevent="openUpdateQuantity(index)"
                    class="cursor-pointer bg-[#b3b3b3] px-[24px] py-[12px] text-black rounded-[5px]"
                  >
                    Edit Quantity
                  </button>
                </td>
                <td class="align-middle">
                  <button
                    @click.prevent="remove(index)"
                    class="cursor-pointer bg-[#DD3636] px-[24px] py-[12px] text-white rounded-[5px]"
                  >
                    Remove
                  </button>
                </td>
              </tr>
              <tr v-if="!orderDetails.length">
                <td colspan="6">
                  <div class="text-center py-[100px]">
                    <h4
                      class="text-[14px] text-[#353535] leading-[20px] font-normal"
                    >
                      No items in order
                    </h4>
                    <p
                      class="text-[#96A0B5] text-[14px] leading-[20px] font-normal my-[8px]"
                    >
                      Click Add item button to add items to order
                    </p>
                    <button
                      :disabled="!value"
                      class="bg-[#2463EB] text-white text-[14px] leading-[20px] border-[#2463EB] border-solid rounded-[8px] outline-none focus:outline-none p-[8px] disabled:cursor-not-allowed"
                      @click="viewAdd"
                    >
                      <span class="mdi mdi-plus"></span>
                      Add item
                    </button>
                  </div>
                </td>
              </tr>

              <tr v-if="orderDetails.length">
                <td colspan="4"></td>
                <td class="text-right">
                  <span
                    class="font-medium text-[14px] leading-[20px] text-[#353535]"
                    >SUBTOTAL</span
                  >
                </td>
                <td class="text-[14px] leading-20px font-normal text-[#353535]">
                  &#8358; {{ formatMoney(subtotal) }}
                </td>
              </tr>
              <tr v-if="orderDetails.length">
                <td colspan="4"></td>
                <td class="text-right">
                  <span
                    class="font-medium text-[14px] leading-[20px] text-[#353535]"
                    >DISCOUNT</span
                  >
                </td>
                <td class="text-[14px] leading-20px font-normal text-[#353535]">
                  &#8358; {{ formatMoney(discount) }}
                </td>
              </tr>

              <tr v-if="orderDetails.length">
                <td colspan="4"></td>
                <td class="text-right">
                  <span
                    class="font-medium text-[14px] leading-[20px] text-[#353535]"
                    >BALANCE</span
                  >
                </td>
                <td class="text-[14px] leading-20px font-normal text-[#353535]">
                  &#8358; {{ formatMoney(total) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="flex justify-end items-center" v-if="orderDetails.length">
          <button
            :disabled="isBusy"
            @click.prevent="checkOrder"
            class="bg-[#2463EB] text-white text-[14px] leading-[20px] border-[#2463EB] border-solid rounded-[8px] outline-none focus:outline-none px-[24px] py-[10px] disabled:bg-blue-400"
          >
            {{ isBusy ? "Loading..." : "Create Order" }}
          </button>
        </div>
      </div>
    </div>

    <!-- add modal -->
    <div class="modal fade py-1" id="mod-add" role="dialog">
      <div class="modal-dialog modal-lg mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Add item to list
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              @click.prevent="onAddCancel"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div
              v-for="(list, index) in productList"
              :key="index"
              class="grid md:grid-cols-2 lg:grid-cols-3 gap-[6px]"
            >
              <div v-for="p in paginatedProducts" :key="p.id" class="w-full">
                <label
                  class="block cursor-pointer bg-white rounded-[10px] p-[10px] w-full h-full flex flex-col justify-between min-h-[200px]"
                >
                  <div>
                    <div class="flex items-center justify-end">
                      <input
                        type="checkbox"
                        :value="p.id"
                        v-model="selectedProducts"
                        class="custom-checkbox"
                        name="selectedProducts"
                      />
                    </div>
                    <div
                      class="w-full flex items-center justify-center mt-[10px]"
                    >
                      <img
                        :src="p.imageUrl"
                        :alt="p.name"
                        class="max-w-[180px] w-full h-[120px] object-contain"
                      />
                    </div>
                    <h2
                      class="text-[14px] font-medium leading-[16.94px] mt-[15px] mb-[4px] text-[#1e1e1e]"
                    >
                      {{ p.name }} &nbsp;({{ p.code }})
                    </h2>
                    <p
                      class="max-w-[600px] w-full text-[12px] font-normal leading-[16.94px] mb-[10px] text-[#353535]"
                      @click="increaseQuantity(list, index)"
                    >
                      &#8358;
                      {{ formatMoney(p.retailPrice) }}/{{ p.unit }}
                    </p>
                  </div>

                  <div
                    v-if="selectedProducts.includes(p.id)"
                    class="w-full flex items-center gap-[10px] mt-auto"
                  >
                    <label
                      class="max-w-max w-full text-[#353535] font-normal m-0 text-[12px] leading-[20px]"
                      >Quantity</label
                    >
                    <div>
                      <input
                        :class="[{ 'is-invalid': v2.quantity }]"
                        step=".01"
                        min="0"
                        type="number"
                        v-model.number="productQuantities[p.id]"
                        class="bg-transparent border-[#A5A5A5] border-solid border-[1.5px] py-[1px] px-[8px] rounded-[5px] w-full outline-none focus:outline-none"
                      />
                      <ul v-if="list.qError" class="parsley-errors-list filled">
                        <li class="parsley-required">
                          Enter a number > 0.
                        </li>
                      </ul>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div
            class="bg-white p-1 rounded-[8px] flex items-center justify-between mt-[16px]"
          >
            <span
              @click="prevPage"
              :class="[
                'text-[14px] font-medium cursor-pointer',
                currentPage > 1
                  ? 'text-[#2463eb]'
                  : 'text-gray-400 cursor-not-allowed',
              ]"
            >
              &lt;&lt; Prev
            </span>
            <span class="text-[#353535] text-[14px]">
              Page {{ currentPage }} of {{ totalPages }}
            </span>
            <span
              @click="nextPage"
              :class="[
                'text-[14px] font-medium cursor-pointer',
                currentPage < totalPages
                  ? 'text-[#2463eb]'
                  : 'text-gray-400 cursor-not-allowed',
              ]"
            >
              Next &gt;&gt;
            </span>
          </div>
          <div
            class="w-full flex flex-col md:flex-row flex wrap gap-[20px] justify-end bg-white p-2 md:p-1 mt-[16px] flex items-center justify-between"
          >
            <div class="w-full">
              <span
                class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              >
                Product Selected ({{ selectedProducts.length }})
              </span>
            </div>
            <div class="flex items-center gap-[8px] max-w-[300px] w-full">
              <button
                class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
                type="button"
                data-dismiss="modal"
                @click.prevent="onAddCancel"
              >
                Cancel
              </button>
              <button
                :disabled="isBusyModal || isQuantityLoading"
                class="bg-[#874fff] border-[#874fff] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
                type="button"
                @click.prevent="add"
              >
                <span v-if="isBusyModal">Busy...</span>
                <span v-else>Done</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- update quantity -->
    <div class="modal fade py-1" id="mod-update-quantity" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <div class="">
              <h4
                class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
              >
                Update Product Quantity
              </h4>
              <span
                class="text-[#353535] text-[14px] font-normal leading-[16.75px] my-[10px]"
                v-if="selectedProductToEdit"
                >{{ selectedProductToEdit.description }}</span
              >
            </div>

            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              @click.prevent="closeUpdateQuantity"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Quantity</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                  step=".01"
                  min="0"
                  max="10"
                  type="number"
                  v-model.number="qtyUpdate"
                />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
              @click.prevent="closeUpdateQuantity"
            >
              <span class="text-danger">Cancel</span>
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="updateProductQuantity"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <CautionModal :products="bridgedProducts" @makeOrder="makeOrder" />
  </div>
</template>
<script>
import moment from "moment";
import { helper } from "@/helper";
import Multiselect from "vue-multiselect";
import CautionModal from "../CautionModal";

Array.prototype.sum = function(prop1, prop2) {
  var total = 0;
  for (var i = 0, _len = this.length; i < _len; i++) {
    total += this[i][prop1] * this[i][prop2];
  }
  return total;
};
export default {
  components: {
    Multiselect,
    CautionModal,
  },
  props: ["closeModal", "refreshOrder"],
  data() {
    return {
      currentPage: 1,
      productsPerPage: 6,
      customers: [],
      value: "",
      canShowCaution: false,
      order: {},
      productInventoryTotal: 0,
      showDetails: false,
      buyerId: null,
      sellerId: null,
      isBusy: false,
      isBusyModal: false,
      isQuantityLoading: false,
      useCredit: false,
      newItem: {},
      salesReps: [],
      salesRepId: null,
      orderDate: moment().format("YYYY-MM-DD"),
      customerOutstandingBalance: 0,
      productList: [],
      selectedProducts: [],
      productQuantities: {},
      v1: {
        sellerId: false,
        deliveryAddress: false,
        orderDate: false,
      },
      v2: {
        productId: false,
        quantity: false,
      },
      isFetchingIntroducer: false,
      products: [],
      filteredProducts: [],
      bridgedProducts: [],
      orderDetails: [],
      discountObj: {},
      discount: 0.0,
      tax: 0.0,
      subtotal: 0.0,
      total: 0.0,
      qtyUpdate: "",
      orderDate: moment().format("YYYY-MM-DD"),
      hasManager: false,
      deliveryAddress: null,
      maxDate: "",
      selectedProductToEdit: null,
      selectedProductIndex: null,
      bridgedProducts: [],
      orderDetails: [],
      discountOnOrder: 0.0,
      useCredit: false,
      newItem: {},
      salesReps: [],
      salesRepId: null,
      orderDate: moment().format("YYYY-MM-DD"),
      customerOutstandingBalance: 0,
      orderPay4MeCredit: 0,
      pay4meStep: 1,
      nextStepMsg: "",
      pay4Status: null,
      pay4Limit: 0,
      payPhoneNumber: "",
      payUserId: "",
      isBusyPay4Me: false,
      payPhoneNumberInvalid: false,
    };
  },

  mounted() {
    this.isBusy = true;
    this.maxDate = helper.preventFutureDateSelection();
    this.isBusy = false;
  },
  watch: {
    orderDetails: {
      handler(newVal, oldVal) {
        this.subtotal = this.orderDetails.sum("quantity", "unitPrice");
        this.discount = parseFloat(this.discountOnOrder);

        if (this.discountObj) {
          this.discount +=
            this.discountObj.type == "Percent"
              ? this.subtotal * (this.discountObj.value / 100)
              : this.discountObj.value;
        }

        for (var i = 0, _len = this.orderDetails.length; i < _len; i++) {
          if (
            this.orderDetails[i].discount !== 0 &&
            this.orderDetails[i].discount !== ""
          )
            this.discount += parseFloat(this.orderDetails[i].discount);
        }

        this.tax = 0;
        this.total = this.subtotal - this.tax - this.discount;
      },
      deep: true,
    },

    discountOnOrder: function(newVal, oldVal) {
      if (oldVal) {
        this.discount -= parseFloat(oldVal);
      }
      if (newVal) {
        this.discount += parseFloat(newVal);
      }
      this.total = this.subtotal - this.tax - this.discount;
    },
  },
  async created() {
    this.getCustomers();
    this.getProducts();
    // this.getSalesReps();

    const id = this.$route.params.id;

    if (id) {
      this.buyerId = id;
      await this.initialize();
    }
  },
  methods: {
    updateQuantity(productId, quantity) {
      const qty = Math.max(0, Number(quantity));
      this.$set(this.productQuantities, productId, qty);
    },
    increaseQuantity(list, index) {
      if (list.quantity < 10) {
        list.quantity++;
        this.onQuantityChangeNew({ target: { value: list.quantity } }, index);
      }
    },
    decreaseQuantity(list, index) {
      if (list.quantity > 0) {
        list.quantity--;
        this.onQuantityChangeNew({ target: { value: list.quantity } }, index);
      }
    },
    formatDate(date) {
      return moment(date).format("ll");
    },

    formatDateWithTime(date) {
      return moment(date).format("ll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    onSelect(option) {
      this.buyerId = option.id;
      this.initialize();
    },
    async getCustomers() {
      await this.$http
        .get("/Users/getItemListOfCustomers/" + this.user.parentId)
        .then(function(res) {
          this.customers = res.body;
        })
        .catch(function(err) {});
    },
    async initialize() {
      if (this.buyerId) {
        this.isBusy = true;
        this.isBusyModal = true;
        await this.$http
          .get("/Orders/initialize/" + this.buyerId)
          .then(function(res) {
            this.order = res.body;
            this.deliveryAddress = res.body.buyer.deliveryAddress;
            this.customerOutstandingBalance = res.body.buyer.accountBalance;
          })
          .catch(function() {
            this.$router.push("/orders");
          });

        this.onSellerChange(this.user.parentId);
        this.getIntroducer();

        this.isBusyModal = false;
        this.isBusy = false;
      }
    },
    onSellerChange(id) {
      this.sellerId = id;
      this.showDetails = true;
      this.orderDetails = [];
      this.getProducts(id);
      this.getDiscount();
    },
    async getIntroducer() {
      this.isFetchingIntroducer = true;
      try {
        const response = await this.$http.get(
          `/Users/${this.buyerId}/introducer`
        );
        if (response.ok) {
          this.salesRepId = response.body;
          this.hasManager = this.salesRepId !== null && this.salesRepId !== "";
        }
      } catch (error) {}

      this.isFetchingIntroducer = false;
    },
    async getProducts(parentId) {
      this.products = [];

      await this.$http
        .get(
          "/Products/getListNoPagingForDistributor?parentId=" +
            parentId +
            "&active=true"
        )
        .then(function(res) {
          this.products = res.body;
        })
        .catch(function() {});
    },
    async getDiscount() {
      await this.$http
        .get(
          "/Discounts/getForOrder?buyerId=" +
            this.buyerId +
            "&sellerId=" +
            this.sellerId
        )
        .then(function(res) {
          this.discountObj = res.body;
        })
        .catch(function() {});
    },
    viewAdd() {
      (this.productList = [
        {
          productIndex: null,
          piError: false,
          quantity: 0,
          qError: false,
          inventoryTotal: 0,
          showCaution: false,
        },
      ]),
        (this.newItem = {
          productIndex: null,
          quantity: null,
        });

      this.v2 = {
        productId: false,
        quantity: false,
      };

      var fProducts = [];

      var details = this.orderDetails;

      this.products.forEach(function(e) {
        if (!details.some((s) => s.code == e.code)) {
          fProducts.push(e);
        }
      });

      this.filteredProducts = fProducts;
      $("#mod-add").modal("show");
    },
    add() {
      if (this.validateAdd()) {
        const plainSelectedProducts = [...this.selectedProducts];
        plainSelectedProducts.forEach((productId) => {
          const product = this.filteredProducts.find((p) => p.id === productId);
          if (product) {
            var p = {
              name: product.name,
              unit: product.unit,
              code: product.code,
              imageUrl: product.imageUrl,
              description: `${product.name} (${product.unit})`,
              unitPrice: product.retailPrice,
              quantity: this.productQuantities[productId] || 1,
              discount: 0,
            };

            this.orderDetails.push(p);
          } else {
            console.error(
              `Product with ID ${productId} not found in filteredProducts`
            );
          }
        });
        $("#mod-add").modal("hide");
        this.canShowCaution = false;
        this.selectedProducts = [];
        this.productQuantities = {};
      }
    },

    async getProducts(parentId) {
      this.products = [];

      await this.$http
        .get(
          "/Products/getListNoPagingForDistributor?parentId=" +
            parentId +
            "&active=true"
        )
        .then(function(res) {
          this.products = res.body;
        })
        .catch(function() {});
    },

    remove(index) {
      this.orderDetails.splice(index, 1);
    },
    addProductList() {
      this.productList.push({
        productIndex: null,
        piError: false,
        quantity: 0,
        qError: false,
        inventoryTotal: 0,
        showCaution: false,
      });
    },
    deleteProductList(index) {
      this.productList.splice(index, 1);
    },
    async onProductSelectNew(event, index) {
      this.productList[index].productIndex = event.target.value;

      this.isQuantityLoading = true;
      try {
        const productId = this.filteredProducts[event.target.value].id;
        const response = await this.$http.get(
          "/Inventories/getProductInventoriesTotal/" + productId
        );

        if (response.ok && response.status === 200) {
          this.productList[index].inventoryTotal = response.body;
        }
        this.isQuantityLoading = false;
      } catch (error) {
        this.isQuantityLoading = false;
      }
    },
    checkProductsStatus() {
      this.orderDetails.forEach((detail) => {
        for (let index = 0; index < this.products.length; index++) {
          const product = this.products[index];

          if (
            detail.code === product.code &&
            product.quantity - detail.quantity < 0
          ) {
            this.bridgedProducts.push({
              name: detail.name,
              neededQuantity: detail.quantity - product.quantity,
              unit: detail.unit,
            });
            break;
          }
        }
      });

      return this.bridgedProducts.length > 0;
    },
    onQuantityChangeNew(event, index) {
      const value = parseFloat(event.target.value);
      if (value < 0 || value > 10) {
        this.productList[index].qError = true;
        return;
      }
      this.productList[index].qError = false;
      const product = this.filteredProducts[index];

      this.productList[index].showCaution =
        this.productList[index].inventoryTotal - event.target.value <=
        product.minimumStockLevel;
    },
    onAddCancel() {
      this.canShowCaution = false;
      this.selectedProducts = [];
      this.productQuantities = {};
    },
    async getDiscount() {
      await this.$http
        .get(
          "/Discounts/getForOrder?buyerId=" +
            this.buyerId +
            "&sellerId=" +
            this.sellerId
        )
        .then(function(res) {
          this.discountObj = res.body;
        })
        .catch(function() {});
    },
    validateAdd() {
      this.v2 = {
        productId: false,
        quantity: false,
      };
      var isValid = true;
      let firstProductId = "";
      const plainSelectedProducts = [...this.selectedProducts];
      for (let i = 0; i < plainSelectedProducts.length; i++) {
        const productId = plainSelectedProducts[i];
        const product = this.filteredProducts.find((p) => p.id === productId);
        if (!product) {
          this.$toast.error("Selected product not found.", {
            icon: true,
            rtl: false,
          });
          return (isValid = false);
        }
        if (i === 0) {
          firstProductId = productId;
        }
        if (firstProductId !== "" && i > 0) {
          if (firstProductId === productId) {
            this.$toast.warning(
              "You cannot add the same product multiple times.",
              {
                icon: true,
                rtl: false,
              }
            );
            return (isValid = false);
          }
        }
        if (!productId) {
          this.v2.productId = true;
          isValid = false;
        }
        const quantity = this.productQuantities[productId] || 0;
        if (Number(quantity) <= 0) {
          this.$set(this.productQuantities, productId, "");
          this.$toast.error("Please enter a valid quantity.", {
            icon: true,
            rtl: false,
          });
          isValid = false;
        }
      }

      return isValid;
    },

    async makeOrder() {
      $("#mod-caution").modal("hide");
      this.isBusy = true;
      this.bridgedProducts = [];

      if (this.validateOrder()) {
        this.orderDetails.forEach((element) => {
          if (element.discount === "") element.discount = 0;
        });

        const data = {
          orderNumber: this.order.orderNumber,
          subtotal: this.subtotal,
          discount: this.discount !== "" ? this.discount : 0,
          tax: this.tax,
          total: this.total,
          parentId: this.user.parentId,
          sellerId: this.sellerId,
          makerId: this.buyerId,
          details: this.orderDetails,
          useCredit: this.useCredit,
          deliveryAddress: this.deliveryAddress,
          introducerId: this.salesRepId,
          orderDate: this.orderDate,
        };
        try {
          const res = await this.$http.post("/Orders/create", data);

          this.isBusy = false;
          this.closeModal();
          this.$toast.success("Order successfully Created.", {
            icon: true,
            rtl: false,
          });
          this.refreshOrder();
        } catch (error) {
        } finally {
          this.isBusy = false;
        }
      } else {
        this.isBusy = false;
      }
    },
    validateOrder() {
      this.v1 = {
        sellerId: false,
        deliveryAddress: false,
        orderDate: false,
      };
      var isValid = true;

      if (!this.sellerId) {
        this.v1.sellerIs = true;
        isValid = false;
      }

      if (!this.deliveryAddress) {
        this.v1.deliveryAddress = true;
        isValid = false;
      }

      if (!this.orderDate) {
        this.v1.orderDate = true;
        isValid = false;
      }

      return isValid;
    },
    openUpdateQuantity(index) {
      this.selectedProductIndex = index;
      this.selectedProductToEdit = this.orderDetails[index];
      this.qtyUpdate = this.orderDetails[index].quantity;
      $("#mod-update-quantity").modal("show");
    },

    closeUpdateQuantity() {
      $("#mod-update-quantity").modal("hide");
      this.qtyUpdate = "";
      this.selectedProductIndex = null;
      this.selectedProductToEdit = null;
    },

    updateProductQuantity() {
      var tempProd = this.orderDetails;
      tempProd[this.selectedProductIndex].quantity = this.qtyUpdate;
      this.orderDetails = tempProd;
      this.closeUpdateQuantity();
    },

    updateStatus() {
      $("#mod-change").modal("hide");
    },

    checkOrder() {
      if (this.validateOrder()) {
        if (this.checkProductsStatus()) $("#mod-caution").modal("show");
        else this.makeOrder();
      }
    },
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.productsPerPage;
      const end = start + this.productsPerPage;
      return this.filteredProducts.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.productsPerPage);
    },
    buyerPhone: function() {
      if (this.order && this.order.buyer && this.order.buyer.phoneNumber) {
        return this.order.buyer.phoneNumber;
      }
      return "";
    },
    buyerEmailAddress: function() {
      if (this.order && this.order.buyer && this.order.buyer.emailAddress) {
        return this.order.buyer.emailAddress;
      }
      return "";
    },
    CreatedOrderBy: function() {
      if (this.order && this.order.buyer && this.order.buyer.createdBy) {
        return this.order.buyer.createdBy;
      }
      return "";
    },
  },
};
</script>
<style scoped>
.custom-checkbox {
  width: 24px;
  height: 24px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
